import { type CSSProperties } from 'react';

import { useTranslation } from 'react-i18next';

import { color, type ColorType } from '@wf/components';

import { ListItemState } from '../../types';

import { toCapitalize } from '../../../../helpers';

import styles from './ItemState.module.scss';

const colorsByState = {
  [ListItemState.Added]: 'indigo',
  [ListItemState.Deleted]: 'error',
  [ListItemState.Changed]: 'success',
};

function ItemState({ state }: { state: ListItemState }) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper} style={{ '--color': color(colorsByState[state] as ColorType) } as CSSProperties}>
      <div className={styles.dot} />
      <div className={styles.text}>{t(toCapitalize(state))}</div>
    </div>
  );
}

export default ItemState;
